import { Title } from 'components/Misc/Typography';
import React from 'react';
import { useMemo } from 'react';
import { priceToReadable } from 'utils/Helpers';

const Summary = ({ payments }) => {
	// Calculate total payment amount
	const amount = useMemo(() => {
		return payments.reduce((result, payment) => {
			return {
				...result,
				total: result.total += Number(payment.amount),
				paid: result.paid += Number(payment.paid)
			};
		}, {
			paid: 0,
			total: 0
		});
	}, [payments]);

	return (
		<div className="flex space-x-4">
			<div className="flex-1 p-4 flex flex-col space-y-1 border rounded-lg dark:border-neutral-700">
				<Title title="Kopā" />
				<div className="font-black text-2xl text-neutral-800 dark:text-white transition-colors">
					{priceToReadable(amount?.total)}
				</div>
			</div>
			
			<div className="flex-1 p-4 flex flex-col space-y-1 border rounded-lg dark:border-neutral-700">
				<Title title="Samaksāts" />
				<div className="font-black text-2xl text-emerald-500">
					{priceToReadable(amount?.paid)}
				</div>
			</div>

			<div className="flex-1 p-4 flex flex-col space-y-1 border rounded-lg dark:border-neutral-700">
				<Title title="Atlicis" />
				<div className="font-black text-2xl text-amber-500">
					{priceToReadable(amount?.total - amount?.paid)}
				</div>
			</div>
		</div>
	);
};

export default Summary;